import { useParams } from '@tanstack/react-router';

import { LubesCreateEnquiryFlow } from './LubesCreateEnquiryFlow';

export const LubesEnquiryDraftPage = () => {
    const { id } = useParams({ from: '/_app/_lubes/orders_/draft/$id' });
    return <LubesCreateEnquiryFlow orderId={id} />;
};
